import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import MainLayout from '../components/Layout/MainLayout';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);

  const handleNavigateToSettings = () => {
    navigate('/global-settings');
  };

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="dashboard-content">
        <div className="welcome-card">
          <h1>Bienvenido al Chatbot de iPlug</h1>
          <p>Has iniciado sesión exitosamente</p>

          <div className="user-info">
            <h3>Información del Usuario</h3>
            <div className="info-grid">
              <div className="info-item">
                <strong>Nombre:</strong>
                <span>{user?.name}</span>
              </div>
              <div className="info-item">
                <strong>Usuario:</strong>
                <span>{user?.userName}</span>
              </div>
              <div className="info-item">
                <strong>Tipo de Tenant:</strong>
                <span>{user?.tenantType}</span>
              </div>
              <div className="info-item">
                <strong>Tenant ID:</strong>
                <span>{user?.tenantId}</span>
              </div>
              <div className="info-item">
                <strong>User ID:</strong>
                <span>{user?.userId}</span>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h3>Accesos Rápidos</h3>
            <div className="actions-grid">
              <button className="action-card" onClick={handleNavigateToSettings}>
                <span className="action-icon">⚙️</span>
                <span className="action-title">Configuraciones Globales</span>
                <span className="action-description">
                  Administra las configuraciones del sistema
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
